const getImgInfo = function (imgUrl,size=40) {
    return new Promise((resolve, reject) => {
    let imgObj = new Image()
    imgObj.src = imgUrl
    imgObj.onload = () => {
        let resizePercent = 0
        let changeWidth = 0
        let changeHeight = 0
        if (imgObj.width > size || imgObj.height > size) {
            if (imgObj.width/imgObj.height > 1) {
                // widthのサイズ変更を基準とする
                resizePercent = size / imgObj.width;
                changeWidth = size;
                changeHeight = imgObj.height * resizePercent;
            } else {
                // heightのサイズ変更を基準とする
                resizePercent = size / imgObj.height;
                changeWidth = imgObj.width * resizePercent;
                changeHeight = size;
            }
        }
      resolve({
        width: changeWidth,
        height: changeHeight
      })
    }
  })
}

// 定義
export { getImgInfo }